//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { GetClientRetailersResponse } from '@apis/campaign-requests/sampling/retailers/samplingRetailersApiModel';
import { CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/CampaignsTrackingId';
import { IDropdownSelectItem } from '@components/molecules/dropdown-select/DropdownSelect';
import { BazaarvoiceClientId } from '@models/BazaarvoiceClientId';
import { isDefined } from '@utils/filterPredicates';

export const transformRetailersToDropdownOptions = (
  data: GetClientRetailersResponse,
): IDropdownSelectItem<BazaarvoiceClientId>[] =>
  data.results.reduce<IDropdownSelectItem<BazaarvoiceClientId>[]>(
    (acc, retailer) => {
      if (
        isDefined(retailer.bvClientId) &&
        isDefined(retailer.clientId) &&
        retailer.catalogSharingEnabled
      ) {
        acc.push({
          label: retailer.bvClientId.toString(),
          value: retailer.bvClientId,
          trackingId:
            CAMPAIGNS_TRACKING_ID.CREATE_SAMPLING_CAMPAIGN_RETAILERS_DROPDOWN_OPTION,
        });
      }
      return acc;
    },
    [],
  );
